import React from 'react'

class TablaItemsConfiguracion extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            pageSize: 5,
            totalCount: 0,
            totalPages: 0,
            search: "",
            loading: false,
            datos: [],
        };
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData = () => {
        const { page, pageSize, search } = this.state;

        this.setState({ loading: true });

        this.props.fetchDatos(page, pageSize, search)
            .then(({ items, totalCount }) => {
                this.setState({
                    datos: items,
                    totalCount,
                    totalPages: Math.ceil(totalCount / pageSize),
                    loading: false,
                });
            })
            .catch((error) => {
                console.error("Error al cargar datos:", error);
                this.setState({ loading: false });
            });
    };

    handleSearchChange = (event) => {
        this.setState({ search: event.target.value, page: 0 }, this.fetchData);
    };

    handlePageChange = (direction) => {
        this.setState(
            (prevState) => ({
                page: direction === "next" ? prevState.page + 1 : prevState.page - 1,
            }),
            this.fetchData
        );
    };

    render() {

        const { titulo, headers, renderFilas } = this.props;
        const { datos, loading, page, pageSize, totalCount, totalPages, search } = this.state;
        let contenidoTabla;
        if (loading) {
            contenidoTabla = (
                <tr>
                    <td colSpan={headers.length} style={{ textAlign: "center", padding: "20px" }}>
                        Cargando...
                    </td>
                </tr>
            );
        } else if (datos.length === 0) {
            contenidoTabla = (
                <tr>
                    <td colSpan={headers.length} style={{ textAlign: "center", padding: "20px" }}>
                        No se encontraron elementos
                    </td>
                </tr>
            );
        } else {
            contenidoTabla = renderFilas(datos);
        }

        return (
            <div className="component-table">
                <div className="component-pagination">
                    <div className="pagination-actions">
                        <form className="search-form form" onSubmit={(e) => e.preventDefault()}>
                            <div className="search-group">
                                <div className="input-icon">
                                    <span className="material-symbols-outlined">search</span>
                                </div>
                                <input
                                    type="search"
                                    className="input-search"
                                    placeholder="Buscar elementos"
                                    value={search}
                                    onChange={this.handleSearchChange}
                                />
                            </div>
                        </form>
                        {datos.length > 0 &&
                            <div className="pagination">
                                <span className="info-pages">
                                    {totalCount === 0
                                        ? "0"
                                        : `${page * pageSize + 1}-${Math.min(
                                            (page + 1) * pageSize,
                                            totalCount
                                        )} de ${totalCount}`}
                                </span>
                                <button
                                    className={`btn-prev ${page === 0 ? "btn-disabled" : ""}`}
                                    onClick={() => this.handlePageChange("prev")}
                                    disabled={page === 0}
                                >
                                    <span className="material-symbols-outlined">navigate_before</span>
                                </button>
                                <button
                                    className={`btn-next ${page >= totalPages - 1 ? "btn-disabled" : ""
                                        }`}
                                    onClick={() => this.handlePageChange("next")}
                                    disabled={page >= totalPages - 1}
                                >
                                    <span className="material-symbols-outlined">navigate_next</span>
                                </button>
                            </div>
                        }

                    </div>
                </div>
                <div className="responsive-table">
                    <table>
                        <thead>
                            <tr>
                                {headers.map((col, index) => (
                                    <th key={index}>{col}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {contenidoTabla}
                        </tbody>
                    </table>
                </div>

            </div>
        );
    }
}

export default TablaItemsConfiguracion;
